import EmptyFeed from "./EmptyFeed"
import { Box } from "@mui/material"
import { createSelector } from "@reduxjs/toolkit"
import { useState } from "react"
import { useOutletContext } from "react-router-dom"
import * as api from "../../app/data/tribeSwaggerApi"
import ErrorPage from "../../pages/ErrorPage/error-page"
import useModalControler from "../../hooks/useModalControler"
import EventDialog from "../popups/EventDialog"
import { feedCardsCont, feedPageCont } from "./feedPageStyles"
import useFeedEventsFilteredList from "../../shared/events-feed/hooks/useFeedEventsFilteredList"
import { LoadingCardsSkeleton } from "./LoadingCardsSkeleton"
import StyledCardLayout from "../StyledCardLayout";
import { useAppSelector } from "../../app/hooks";
import { selectFilter } from "../../shared/filter/selectors";

type AvatarUrls = Record<number, string[]>

export const getAvatarUrls = createSelector(
  (response: api.GetAllEventByFilterApiResponse) => response.content,
  (events: api.SearchEventDto[]) =>
    events.reduce((acc: AvatarUrls, event) => {
      if (event.avatarUrl && event.eventId) {
        acc[event.eventId] = event.avatarUrl.flatMap(
          (url: string) =>
            `${import.meta.env.VITE_AVATAR_URL}/v1/events/avatars/${url}`,
        )
      }
      return acc
    }, {}),
)

const FeedPage = () => {
  const { mounted, handleToggleMounted } = useModalControler()
  const [modalLink, setModalLink] = useState("")
  const { isLoading, error, filteredList, pagination } =
    useFeedEventsFilteredList()

  const filter = useAppSelector(selectFilter)
  const feedOff = filter.showAll !== true && !(Array.isArray(filter.eventTypeId) && filter.eventTypeId.length > 0)

  const context = useOutletContext<{ gridView?: string }>()
  const gridView = context?.gridView ?? 'single'

  const gridStyles = gridView === 'double'
    ? {
        ...feedCardsCont,
        gridTemplateColumns: "repeat(2, 1fr)",
        columnGap: "6px",
        rowGap: "6px",
        alignItems: "start",
        "& > *": {
          height: "auto",
          minHeight: "unset",
        }
      }
    : feedCardsCont

  if (feedOff) {
    return (
      <div style={feedPageCont}>
        <Box sx={{ textAlign: "center", padding: "48px 16px", color: "var(--secondary-text)", fontSize: "16px" }}>
          Выберите категорию или нажмите «Все»
        </Box>
      </div>
    )
  }
  if (error) {
    return <ErrorPage error={error} />
  }
  if (pagination && pagination?.totalElements === 0) {
    return (
      <div style={feedPageCont}>
        <EmptyFeed />
      </div>
    )
  }
  return (
    <div style={feedPageCont}>
      <Box sx={gridStyles}>
        {isLoading && !error ? <LoadingCardsSkeleton /> : null}
        {filteredList && (
          <StyledCardLayout events={filteredList} gridView={gridView} />
        )}
      </Box>
      <EventDialog
        isVisible={mounted}
        visibleToggler={handleToggleMounted}
        eventLink={modalLink}
      />
    </div>
  )
}
export default FeedPage
